module.exports = __webpack_public_path__ + "img/SEEBA.bf42ff23.svg";